import { takeUntil, scan, startWith, take, bufferCount, mergeAll,catchError, map, concatMap, exhaustMap, withLatestFrom, filter, switchMap,takeLast,skipUntil, delay,delayWhen, tap, buffer,bufferWhen, bufferToggle  } from 'rxjs/operators';
import { noop, Observable, EMPTY, of, OperatorFunction, MonoTypeOperatorFunction,from,ObservableInput } from 'rxjs';


export function bufferWhile<T>(trigger$: Observable<boolean>): OperatorFunction<T, T> {
  return (source$: Observable<T>) => {
    return new Observable<T>((subscriber) => {
      let buffer: T[] = [];  // To store buffered values

      // Subscription to the source observable
      const sourceSubscription = source$.subscribe({
        next(value) {
          // If the trigger is true, we just emit the value
          trigger$.pipe(
            takeUntil(trigger$.pipe(filter(value => !value))) // Wait until trigger is true
          ).subscribe({
            next(triggerValue) {
              if (triggerValue) {
                // If the trigger is true, emit all buffered values first
                if (buffer.length > 0) {
                  buffer.forEach(val => subscriber.next(val));  // Emit the buffered values
                  buffer = [];  // Clear the buffer
                }
                subscriber.next(value);  // Now emit the current value
              } else {
                // If the trigger is false, buffer the value
                buffer.push(value);
              }
            }
          });
        },
        error(err) {
          subscriber.error(err);  // Propagate any errors
        },
        complete() {
          subscriber.complete();  // Complete when the source completes
        },
      });

      // Cleanup the subscription when the observable is unsubscribed
      return () => sourceSubscription.unsubscribe();
    });
  };
}
